import styled, { css } from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos Accounting
Description : Se definen los estilos de los elementos del resto del formulario
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se defienen estilos y elementos del formulario
================================================================================ */

export const FormGroup = styled.div`
    color: palevioletred;
    width: 300px;
    height: 30px;
    margin: 50px;
    margin-top: -5px;
`;

export const Form = styled.form`
    /* padding-top: 20px; */
    padding-left: 20px;
    border-radius: 8px;
    /* width: 100%; */
    /* border: 2px solid black; */
    /* margin: 0 auto; */
    @media screen and (max-width: 960px){
        /* margin-top: 100px; */
        /* margin-bottom: 0px; */
    }
`;

export const Forms = styled.div`
    margin: auto;
    @media screen and (max-width: 960px){
        margin-top: 90px;
    }
`

export const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    //height: 10vh;
`

export const Button = styled.button`
    padding-right: 50px;
    padding-left: 50px;
    margin-top: 10px;
`;

export const Label = styled.label`
    display: flex;
    margin-top: -5px;
    justify-content: center;
    align-items: center;
    margin-left: 0px;
    margin-bottom: 5px;
    font-size: 14px;
    @media screen and (max-width: 960px){

    }
`;

export const Input = styled.input`
	padding: 0.5em;
	width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
`;

export const Image = styled.img`
    width: 40%;
    margin-top: 0.5em;
`;

export const H2 = styled.h2`
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    z-index: 1;
    &:before {
        border-top: 1px solid #1061a2;
        content: "";
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        bottom: 0;
        width: 75%;
        z-index: -1;
    };
`;

export const Span = styled.span`
    background: #fff;
    padding: 0;
`;

export const Select2 = styled.select`
    padding: 0.5em;
    width:100%;
    margin-top: -3px;
    margin-bottom: 2px;

    option {
        display: flex;
        white-space: pre;
        min-height: 20px;
        padding: 0px 2px 1px;
    }
`;

export const H3 = styled.h3`
    margin-bottom: 20px;
`;

export const Title_modal = styled.h1`
	font-size: 30px;
`;
export const Modal_header = styled.div`
    text-align: center;
    width: 100%;
`;
export const LabelField = styled.label`
    display: block;
    float: left;
    margin-top: 5px;
    width: 100%;
    padding-top: 5px;
`;

export const DeletedButton = styled.div`
    button{
        display: none;
    }
`;

export const CloseButton = styled.button`
    //padding-right: 50px;
    //padding-left: 50px;
    align-self: right;
    background-color: red;
`;